import React, { useEffect, useRef } from "react";
import { createUseStyles } from "react-jss";
import Portal from "HOC/Portal";
import { SearchResults } from "Containers/SearchAI";
import SearchIcon from "Assets/images/search_icon.svg";
import CloseIcon from "Assets/images/close.svg";
import styles from "./styles";

interface SearchAIProps {
  onClick: () => void;
  onInputClick: (e: React.MouseEvent<HTMLInputElement>) => void;
  onSearchClick: (e, searchValue: string) => void;
  onChange: (e) => void;
  onClear: (e) => void;
  onKeyDown: (e) => void;
  showResults: boolean;
  searchInputValue: string;
  mapObj: any;
}

const SearchAIPrompt = ({
  onClick,
  onInputClick,
  onSearchClick,
  onChange,
  onClear,
  onKeyDown,
  showResults,
  searchInputValue,
  mapObj,
}: SearchAIProps) => {
  const useStyles = createUseStyles(styles);
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement>(null);
  const closeButtonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  useEffect(() => {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        onClick && onClick();
      }
    });

    const handleTabFromCloseButton = (e: KeyboardEvent) => {
      if (document.activeElement === closeButtonRef.current) {
        if (e.key === "Tab" && !e.shiftKey) {
          e.preventDefault();
          inputRef.current?.focus();
        } else if (e.key === "Tab" && e.shiftKey) {
          e.preventDefault();
          inputRef.current?.focus();
        }
      }
    };

    const closeButtonEl = closeButtonRef.current;
    closeButtonEl?.addEventListener("keydown", handleTabFromCloseButton);

    return () => {
      closeButtonEl?.addEventListener("keydown", handleTabFromCloseButton);
      document.addEventListener("keydown", () => {});
    };
  }, [onClick]);

  return (
    <Portal>
      <div
        id="close-search-results"
        aria-label="close search results"
        className={classes.container}
      >
        <div className={classes.inputContainer}>
          <SearchIcon
            className={classes.searchIcon}
            onClick={(e) => onSearchClick(e, searchInputValue)}
          />
          <input
            id="search-input"
            ref={inputRef}
            className={classes.searchBar}
            placeholder="What would you like to see?"
            onClick={onInputClick}
            onChange={onChange}
            value={searchInputValue}
            onKeyDown={onKeyDown}
          />
          <button onClick={onClick} className={classes.cancelText}>
            Cancel
          </button>
          {searchInputValue && (
            <button
              aria-label="Clear input text"
              className={classes.closeIcon}
              onClick={onClear}
            >
              <CloseIcon role="button" onClick={onClear} />
            </button>
          )}
        </div>
        {showResults && <SearchResults mapObj={mapObj} />}
      </div>
      <button
        ref={closeButtonRef}
        tabIndex={0}
        aria-label="Close Search Modal"
        className={classes.closeModalIcon}
        onClick={onClick}
      >
        <CloseIcon />
      </button>
    </Portal>
  );
};

export default SearchAIPrompt;
try {
    // @ts-ignore
    SearchAIPrompt.displayName = "SearchAIPrompt";
    // @ts-ignore
    SearchAIPrompt.__docgenInfo = { "description": "", "displayName": "SearchAIPrompt", "props": { "onClick": { "defaultValue": null, "description": "", "name": "onClick", "required": true, "type": { "name": "() => void" } }, "onInputClick": { "defaultValue": null, "description": "", "name": "onInputClick", "required": true, "type": { "name": "(e: any) => void" } }, "onSearchClick": { "defaultValue": null, "description": "", "name": "onSearchClick", "required": true, "type": { "name": "(e: any, searchValue: string) => void" } }, "onChange": { "defaultValue": null, "description": "", "name": "onChange", "required": true, "type": { "name": "(e: any) => void" } }, "onClear": { "defaultValue": null, "description": "", "name": "onClear", "required": true, "type": { "name": "(e: any) => void" } }, "onKeyDown": { "defaultValue": null, "description": "", "name": "onKeyDown", "required": true, "type": { "name": "(e: any) => void" } }, "showResults": { "defaultValue": null, "description": "", "name": "showResults", "required": true, "type": { "name": "boolean" } }, "searchInputValue": { "defaultValue": null, "description": "", "name": "searchInputValue", "required": true, "type": { "name": "string" } }, "mapObj": { "defaultValue": null, "description": "", "name": "mapObj", "required": true, "type": { "name": "any" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/SearchAI/SearchAIPrompt.tsx#SearchAIPrompt"] = { docgenInfo: SearchAIPrompt.__docgenInfo, name: "SearchAIPrompt", path: "src/shared/components/SearchAI/SearchAIPrompt.tsx#SearchAIPrompt" };
}
catch (__react_docgen_typescript_loader_error) { }